import { gridSizeMdLg6, newAreasSchema } from '@/shared';
import {
  useCreateArea,
  useUpdateArea,
  usefetchEmpresas,
} from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
  TabTextLabel,
} from '@/shared/components/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Area, Empresa } from '@/shared/interfaces';
import { DAYS_WEEK_COLLECTION, diasPermitidosInterface, WorkDaysCollection } from '@/shared/interfaces/erp/global/days.interface';
import TimeClockComponente from '@/shared/components/ui/TimeClock/TimeClockComponente';
import { AcutocompletePromocion } from '@/erp/sytem-sttings/promociones/shared/components';
import { getDiasPermitidos, getTimesForClockInWorkSchedules, hoursBetweenRange } from '@/shared/utils/horarios-acceso-usuarios';
const returnUrlAreas = '/parametrizacion/areas';

export interface SaveAreaInterface {
  titlePage: string;
  editArea?: Area;
}
type SaveFormData = {
  nombre: string;
  //codigo: string;
  estado: boolean;
  empresa: string;
  
  // to handle users schedule
  workDays?: number[];
  hora_inicio_jornada?: Date;
  hora_fin_jornada?: Date;
  dias_permitidos?: diasPermitidosInterface[] | [] | null;
};
const SaveAreaPage: React.FC<SaveAreaInterface> = ({ titlePage, editArea }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createAreaMutation = useCreateArea({
    navigate,
    returnUrl: returnUrlAreas,
  });
  const updateAreaMutation = useUpdateArea({
    navigate,
    returnUrl: returnUrlAreas,
  });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newAreasSchema),
    defaultValues: { estado: false }, // Set default value for estado
  });
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {

    if (!isValid) return;
    console.log("debug",form.getValues())

    //Obtiene valores de dias_permitidos para los horarios laborales
    const hoursToWork = hoursBetweenRange(form.getValues().hora_inicio_jornada?.getHours()!, 
                      form.getValues().hora_fin_jornada?.getHours()!);
    const daysToWork = form.getValues().workDays;
    let aux_dias_permitidos:any = null;
    if(hoursToWork && daysToWork){
      aux_dias_permitidos = getDiasPermitidos(hoursToWork, daysToWork)
    }
    console.log("debug", form.getValues())

    ///* upd
    if (editArea?.id_area) {
      return updateAreaMutation.mutate({
        id: editArea.id_area,
        data: {
          ...form.getValues() as any,
          dias_permitidos: aux_dias_permitidos,

        }, // percent
      });
    }

    ///* create
    return createAreaMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    // console.log({workwork:editArea?.dias_permitidos?.map((item: any) => item.dia)})
    if (!editArea) return;
    // console.log("debug", getTimesForClockInWorkSchedules(editArea.dias_permitidos?.[0]?.horas!))
    const [horaInicio, horaFin] = getTimesForClockInWorkSchedules(editArea.dias_permitidos?.[0]?.horas!)
    // if (editArea) {
    setShrink(true);
    form.reset({
      ...editArea,
      workDays: editArea.dias_permitidos?.map((item: any) => item.dia),
      hora_inicio_jornada: horaInicio!,
      hora_fin_jornada: horaFin!,
    });
    // }
    // console.log(editArea)
  }, [editArea]);

  const { data: EmpresaPaging, isLoading: isLoadingEmpresa } = usefetchEmpresas(
    {
      page_size: 600,
    }
  );
  const onChangeEmpresa = (value: string) => {
    form.setValue('empresa', value);
  };

  const auxDias = editArea?.dias_permitidos?.map((item: any) => item.dia)
  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlAreas);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
        shrink={shrink}
      />
      {/* <CustomTextField
        label="Codigo"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.codigo}
        helperText={errors.codigo?.message ?? ''}
        shrink={shrink}
      /> */}

      <CustomAutocomplete<Empresa>
        label="Empresa"
        name="empresa"
        //// options
        options={EmpresaPaging?.data.data || []}
        // label & search by name
        valueKey="razon_social"
        actualValueKey="codigo"
        //
        defaultValue={form.getValues().empresa || ''}
        optionLabelForEdit={form.getValues().empresa || ''}
        isLoadingData={isLoadingEmpresa}
        //// validation
        control={control}
        error={errors.empresa}
        helperText={errors.empresa?.message}
        onChangeValue={onChangeEmpresa}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={form.getValues().estado || false} // Set default value to false
      />

      {/* ---------- Horarios --------- */}
      <TabTextLabel text="Horario de Empleado" pt="39px" pb="3px" />
      <AcutocompletePromocion<WorkDaysCollection>
        label="Días laborales"
        name="workDays"
        textFieldKey="workDays"
        valueKey="nombreDia"
        actualValueKey="dia"
        // options
        options={DAYS_WEEK_COLLECTION?.data || []}
        defaultValue={
          // avoid error reference
          DAYS_WEEK_COLLECTION?.data.filter((item: WorkDaysCollection) =>
            auxDias?.includes(item.dia!))
        }
        isLoadingData={false}
        // errors
        control={form.control}
        error={!!errors.workDays}
        helperText={errors.workDays?.message}
        onChangeRawValue={v => {
          form.setValue(
            'workDays',
            v?.map((item: WorkDaysCollection) => item?.dia!)
          );
        }}
      />
      <TimeClockComponente
        size={gridSizeMdLg6}
        control={form.control}
        error={errors.hora_inicio_jornada}
        // helperText={""}//errors.hora_inicio?.message}
        label='Hora de inicio jornada'
        name='hora_inicio_jornada'
        enableDateTypeResult={true}
      />
      <TimeClockComponente
        size={gridSizeMdLg6}
        control={form.control}
        error={errors.hora_fin_jornada}
        // helperText={""}//errors.hora_inicio?.message}
        label='Hora de fin jornada'
        name='hora_fin_jornada'
        enableDateTypeResult={true}
      />
    </SingleFormBoxScene>
  );
};

export default SaveAreaPage;